"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var RetriggerIcon = function RetriggerIcon(_ref) {
  var width = _ref.width,
    height = _ref.height,
    className = _ref.className,
    color = _ref.color,
    title = _ref.title;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: width,
    height: height,
    viewBox: "0 0 21 15",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .29h15.088233v9.6798H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.697018.3204H15.7626V10H.697018z"
  })), /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .71)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.8947 3.2598c-.279.3-.76.33-1.06.05-1.08-.98-2.48-1.52-3.929-1.52-3.031 0-5.54 2.321-5.83 5.27l1.21-1.21c.29-.3.759-.3 1.059 0 .29.29.29.77 0 1.06l-3.059 3.06-3.061-3.06c-.3-.29-.3-.77 0-1.06.29-.3.761-.3 1.061 0l1.29 1.29c.25-3.819 3.439-6.85 7.33-6.85 1.83 0 3.58.68 4.939 1.91.3.281.33.75.05 1.06",
    fill: color,
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 5.71)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.5451 4.4404c-.14.14-.34.22-.53.22s-.38-.08-.53-.22l-1.26-1.261c-.27 3.811-3.451 6.821-7.32 6.821-1.85 0-3.61-.691-4.97-1.93-.3-.28-.32-.75-.04-1.061.28-.309.75-.33 1.06-.049 1.08.99 2.48 1.54 3.95 1.54 3.03 0 5.54-2.331 5.82-5.3l-1.24 1.24c-.29.29-.77.29-1.06 0-.29-.301-.29-.771 0-1.061l3.06-3.059 3.06 3.059c.29.29.29.76 0 1.061",
    fill: color,
    mask: "url(#d)"
  }))));
};
var defaultProps = {
  color: _constants.colors.mediumGrey,
  width: 20,
  height: 20,
  title: 'Retrigger'
};
RetriggerIcon.defaultProps = defaultProps;
var _default = RetriggerIcon;
exports["default"] = _default;